<template lang="pug">
span
  v-btn(small color='primary' 
      @click="toggle" 
      :disabled="isDisabled"
      outlined
    ) Test
  confirmation-dialog(
    v-model="showing"
    @okBtnClicked="test"
    @failBtnClicked="toggle"
    title="Test candidate"
    descr="Are you sure you want to test candidate?"
    okText="ok"
    failText="cancel"
  )
</template>

<script>
import errorsMixin from '@/mixins/errors.mixin'

export default {
  inject: ['svc'],
  mixins: [errorsMixin],

  props: {
    activeItems: {
      type: Array,
      required: true
    },
    disabled: Boolean
  },

  data: () => ({
    showing: false
  }),

  computed: {
    isDisabled() {
      if(this.disabled || !this.activeItems.length) return true
      return false
    }
  },

  methods: {
    toggle() {
      this.showing = !this.showing
    },

    async test(payload) {
      try {
        let ids = this.activeItems.map(item => item.ID)
        let res = await this.svc().testAccept(ids)
        this.$notify({text: 'Started accepting', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    }
  },

  components: {
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue')
  }
}
</script>